import { useState } from "react";
import { FileText, Download } from "lucide-react";
import { C, Panel, Serif, Label } from "./ui";
import { REPORTS } from "./adminData";

export default function Reports() {
  const [sel, setSel] = useState(0);
  return (
    <div>
      <Label>Analytics</Label>
      <Serif size={26} style={{ marginTop: 4, marginBottom: 6 }}>Reports</Serif>
      <div style={{ fontSize: 12, color: C.slate, marginBottom: 18 }}>The five legacy report types, rebuilt on live data.</div>

      <div style={{ display: "grid", gridTemplateColumns: "minmax(0,1fr) minmax(0,1fr)", gap: 16 }}>
        <div style={{ display: "grid", gap: 10, alignContent: "start" }}>
          {REPORTS.map((r, i) => (
            <div key={i} onClick={() => setSel(i)} data-testid={`report-${i}`}
              style={{ display: "flex", gap: 12, padding: 15, background: "#fff", border: `1px solid ${sel === i ? C.navy : "rgba(26,30,36,0.08)"}`, borderRadius: 10, cursor: "pointer" }}>
              <div style={{ width: 38, height: 38, borderRadius: 8, background: `${C.navy}0f`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><FileText size={18} color={C.navy} /></div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 700, color: C.ink }}>{r.name}</div>
                <div style={{ fontSize: 12, color: C.slate, marginTop: 2 }}>{r.desc}</div>
              </div>
            </div>
          ))}
        </div>

        <Panel>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
            <Label>{REPORTS[sel].name}</Label>
            <button data-testid="report-export" style={{ display: "flex", alignItems: "center", gap: 6, padding: "8px 13px", background: C.green, color: "#fff", border: 0, borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: "pointer" }}><Download size={13} /> Export</button>
          </div>
          <div style={{ fontSize: 12, color: C.slate, marginBottom: 14, fontFamily: "'JetBrains Mono', monospace" }}>{REPORTS[sel].rows}</div>
          <div style={{ display: "grid", gap: 8 }}>
            {[["Indwe", "2,394", "755"], ["Enviroserve", "203", "163"], ["Simah", "200", "139"], ["BornmanMarlow", "138", "6"]].map(([a, b, c]) => (
              <div key={a} style={{ display: "grid", gridTemplateColumns: "1fr auto auto", gap: 14, padding: "10px 0", borderTop: "1px solid rgba(26,30,36,0.06)", fontSize: 13 }}>
                <span style={{ fontWeight: 600 }}>{a}</span>
                <span style={{ fontFamily: "'JetBrains Mono', monospace", color: C.slate }}>{b} total</span>
                <span style={{ fontFamily: "'JetBrains Mono', monospace", color: C.green }}>{c} app</span>
              </div>
            ))}
          </div>
        </Panel>
      </div>
    </div>
  );
}
